<template>
  <div v-if="nextWindowId" class="absolute bottom-4 right-4 z-50">
    <button
      type="button"
      @click="goToNext"
      class="next-button flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg shadow-lg hover:bg-blue-700 transition-colors font-trebuchet-pixel text-sm"
    >
      <span>{{ $t('windows.tourGuide.next') }}</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M5 12h14M12 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  currentWindowId: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['open-window', 'minimize-window'])

// Ordre des fenêtres dans le parcours guidé
const tourOrder = [
  'about',
  'academicPath',
  'competences',
  'activites',
  'reseau',
  'contact',
  'thankYou'
]

const nextWindowId = computed(() => {
  const currentIndex = tourOrder.indexOf(props.currentWindowId)
  if (currentIndex !== -1 && currentIndex < tourOrder.length - 1) {
    return tourOrder[currentIndex + 1]
  }
  return null
})

const goToNext = (event) => {
  if (event) {
    event.preventDefault()
    event.stopPropagation()
  }
  if (nextWindowId.value) {
    // Minimiser la fenêtre actuelle
    emit('minimize-window', props.currentWindowId)
    // Ouvrir la fenêtre suivante
    emit('open-window', nextWindowId.value)
  }
}
</script>

<style scoped>
/* Animation de pulsation pour le bouton suivant */
.next-button {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.7);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(37, 99, 235, 0);
  }
}

.next-button:hover {
  animation: none;
  transform: scale(1.05);
}
</style>

